import React, { type HTMLAttributes } from 'react';
import styled from 'styled-components';
import { FontWeightSemiBold, Spacing8 } from 'autogen/design-tokens/tokens';
import type { ProductNameLine } from 'autogen/swagger/all';
import { Typography } from 'components/generic/typography';

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: auto;
    grid-auto-columns: auto;
    row-gap: ${Spacing8};
`;

const Brand = styled(Typography.Label)``;

const Title = styled(Typography.Headline)`
    font-weight: ${FontWeightSemiBold};
    margin-top: 0;
    margin-bottom: 0;
`;

function PageTitleNameRenderer({
    lines,
    ...restProps
}: { lines: ProductNameLine[] } & HTMLAttributes<HTMLDivElement>): JSX.Element {
    const brand = lines.find((line) => line.type === 'Brand');
    const name = lines.find((line) => line.type === 'Name');

    return (
        <Wrapper {...restProps}>
            {brand && <Brand size="L">{brand.url ? <a href={brand.url}>{brand.value}</a> : brand.value}</Brand>}

            {name && (
                <Title forwardedAs="h1" size="L">
                    {name.value}
                </Title>
            )}
        </Wrapper>
    );
}

export default PageTitleNameRenderer;
